<template>
  <div id="app_wrapper">
    <div id="main_menu">
      <img src="@/assets/img/prometco-logo.png" id="logo" />

      <div class="menu_item" :class="{selected: current_section == 1}" @click="set_section(1)">
        <div class="menu_icon icon_01"></div>
        <p>Treatment pathway</p>
      </div>

      <div class="menu_item" :class="{selected: current_section == 2}" @click="set_section(2)">
        <div class="menu_icon icon_02"></div>
        <p>Efficacy outcomes</p>
      </div>

      <div class="menu_item" :class="{selected: current_section == 3}" @click="set_section(3)">
        <div class="menu_icon icon_03"></div>
        <p>Conclusions</p>
      </div>
    </div>

    <div class="top_icon" :class="get_icon_class"></div>

    <div class="top_nav_wrapper" :class="{'conclusions' : current_animation == 'anim_09'}">
      <h1 v-if="current_animation == 'anim_09'">Conclusions</h1>

      <div class="top_nav" v-if="current_section == 1">
        <button :class="{selected: (current_animation == 'anim_01')}" @click="set_graph('anim_01')">Study population</button>
        <button :class="{selected: (current_animation == 'anim_02')}" @click="set_graph('anim_02')">Most frequent 4 LoTs</button>
      </div>

      <div class="top_nav" v-if="current_section == 2">
        <button :class="{selected: (current_animation == 'anim_03' || current_animation == 'anim_04')}" @click="set_graph('anim_03')" class="ls-1">Overall survival</button>
        <button :class="{selected: (current_animation == 'anim_05' || current_animation == 'anim_06')}" @click="set_graph('anim_05')" class="ls-1">Patients treated with FTD/TPI + bevacizumab</button>
        <button :class="{selected: (current_animation == 'anim_07' || current_animation == 'anim_08')}" @click="set_graph('anim_07')" class="ls-1">Multivariable analysis</button>
      </div>
      

      <div class="sub_nav" v-show="(current_animation == 'anim_03' || current_animation == 'anim_04')">
        <button :class="{selected: current_animation == 'anim_03'}" @click="set_graph('anim_03')">Treatment pathway in patients with 3 LoTs</button>
        <button :class="{selected: current_animation == 'anim_04'}" @click="set_graph('anim_04')">Treatment pathway in patients with 4 LoTs</button>
      </div>

      <div class="sub_nav" v-show="(current_animation == 'anim_05' || current_animation == 'anim_06')">
        <button :class="{selected: current_animation == 'anim_05'}" @click="set_graph('anim_05')">Patient stratification</button>
        <button :class="{selected: current_animation == 'anim_06'}" @click="set_graph('anim_06')">Survival outcomes</button>
      </div>

      <div class="sub_nav" v-show="(current_animation == 'anim_07' || current_animation == 'anim_08')">
        <button :class="{selected: current_animation == 'anim_07'}" @click="set_graph('anim_07')">Factors influencing OS from PROMETCO inclusion</button>
        <button :class="{selected: current_animation == 'anim_08'}" @click="set_graph('anim_08')">Factors influencing OS from 1L</button>
      </div>

    </div>

    <div id="main_content">

      <div class="anim-02" v-if="current_animation == 'anim_02'">
        <div class="anim-bg anim-02-bg"></div>
        <div class="anim-frame anim-02-01" :class="{'visible': anim_02_vis[0]}"></div>
        <div class="anim-frame anim-02-02" :class="{'visible': anim_02_vis[1]}"></div>
        <div class="anim-frame anim-02-03" :class="{'visible': anim_02_vis[2]}"></div>
        <div class="anim-frame anim-02-04" :class="{'visible': anim_02_vis[3]}"></div>

        <div class="anim-02-btn anim-02-btn-01" @click="swap_anim(0)"></div>
        <div class="anim-02-btn anim-02-btn-02" @click="swap_anim(1)"></div>
        <div class="anim-02-btn anim-02-btn-03" @click="swap_anim(2)"></div>
        <div class="anim-02-btn anim-02-btn-04" @click="swap_anim(3)"></div>
      </div>


      <div class="anim-06" v-if="current_animation == 'anim_06'">
        <div class="anim-bg anim-06-bg"></div>
        <div class="anim-frame anim-06-01" :class="{'visible': anim_06_vis[0]}"></div>
        <div class="anim-frame anim-06-02" :class="{'visible': anim_06_vis[1]}"></div>
        <div class="anim-frame anim-06-03" :class="{'visible': anim_06_vis[2]}"></div>

        <div class="anim-06-btn anim-06-btn-01" @click="swap_anim(0)"></div>
        <div class="anim-06-btn anim-06-btn-02" @click="swap_anim(1)"></div>
        <div class="anim-06-btn anim-06-btn-03" @click="swap_anim(2)"></div>
      </div>
      
      <Vue3Lottie assetsPath="/interactive-2026-01/graphs/anim_01/images/" :loop="false" :animationData="anim_01_JSON" :width="980" :height="520" v-if="current_animation == 'anim_01'" autoPlay="true" />
      <Vue3Lottie assetsPath="/interactive-2026-01/graphs/anim_03/images/" :loop="false" :animationData="anim_03_JSON" :width="980" :height="520" v-if="current_animation == 'anim_03'" autoPlay="true" />
      <Vue3Lottie assetsPath="/interactive-2026-01/graphs/anim_04/images/" :loop="false" :animationData="anim_04_JSON" :width="980" :height="520" v-if="current_animation == 'anim_04'" />
      <Vue3Lottie assetsPath="/interactive-2026-01/graphs/anim_05/images/" :loop="false" :animationData="anim_05_JSON" :width="980" :height="520" v-if="current_animation == 'anim_05'" />
      <!--<Vue3Lottie assetsPath="/interactive-2026-01/graphs/anim_06/images/" :loop="false" :animationData="anim_06_JSON" :width="980" :height="520" v-if="current_animation == 'anim_06'" />-->
      <Vue3Lottie assetsPath="/interactive-2026-01/graphs/anim_07/images/" :loop="false" :animationData="anim_07_JSON" :width="980" :height="520" v-if="current_animation == 'anim_07'" />
      <Vue3Lottie assetsPath="/interactive-2026-01/graphs/anim_08/images/" :loop="false" :animationData="anim_08_JSON" :width="980" :height="520" v-if="current_animation == 'anim_08'" />
      <Vue3Lottie assetsPath="/interactive-2026-01/graphs/anim_09/images/" :loop="false" :animationData="anim_09_JSON" :width="980" :height="520" v-if="current_animation == 'anim_09'" />

    </div>
    

    <div id="footer">
      <div class="servier_logo"></div>
      <p>PROMETCO: Real-world characteristics and safety outcomes of patients with metastatic colorectal cancer (mCRC) after two disease progressions, including patients with an ECOG PS &ge;2</p>
    </div>

    <div class="conc_btn" v-if="current_animation == 'safety_03-ae-summary'">
        <div class="iBtn" id="iBtn1" @click="int_click(1, 1)"></div>
    </div>
    <div class="conc_btn" v-if="current_animation == 'bc_meta'">
        <div class="iBtn" id="iBtn2" @click="int_click(1, 2)"></div>
    </div>

  </div>
</template>

<script>
import { Vue3Lottie } from 'vue3-lottie'

import anim_01_JSON from '@/assets/graphs/anim_01/data.json'
import anim_03_JSON from '@/assets/graphs/anim_03/data.json'
import anim_04_JSON from '@/assets/graphs/anim_04/data.json'
import anim_05_JSON from '@/assets/graphs/anim_05/data.json'
//import anim_06_JSON from '@/assets/graphs/anim_06/data.json'
import anim_07_JSON from '@/assets/graphs/anim_07/data.json'
import anim_08_JSON from '@/assets/graphs/anim_08/data.json'
import anim_09_JSON from '@/assets/graphs/anim_09/data.json'

export default {
  name: 'App',
  components: {
    Vue3Lottie
  },
  mounted()
  {
    /*window.addEventListener('set_section', (e) => {
      alert(JSON.stringify(e));
    });*/

    window.addEventListener('message', this.receiveMessage, false);
  },
  methods:
  {
    receiveMessage(event) {
      if (event.type == "message" && event.data.set_section != undefined)
      {
        console.log(event.data.set_section);
        this.set_section(event.data.set_section);
        //console.log(event.type);
      }
      
      //alert(JSON.stringify(event));
    },
    enterFrame()
    {
      //console.log(this.$refs.interactive_1.getCurrentFrame());
    },
    animComplete()
    {
      
    },
    swap_anim(anim_index)
    {
      if (this.current_animation == "anim_02")
      {
        for (var a = 0; a < 4; a++)
        {
          this.anim_02_vis[a] = false;
        }
        this.anim_02_vis[anim_index] = true;
      }
      else
      {
        for (a = 0; a < 4; a++)
        {
          this.anim_06_vis[a] = false;
        }
        this.anim_06_vis[anim_index] = true;
      }
      
    },
    set_section_from_html(event)
    {
      //alert(JSON.stringify(event));
      this.set_section(event.index);
    },
    set_section(index)
    {
      this.current_section = index;

      if (index == 1)
      {
        this.set_graph('anim_01');
      }
      else if (index == 2)
      {
        this.set_graph('anim_03');
      }
      else if (index == 3)
      {
        this.set_graph('anim_09');
      }
    },
    set_graph(graph_index)
    {
      this.current_animation = graph_index;
      this.anim_02_vis = [true, false, false, false];
      this.anim_06_vis = [true, false, false, false];
    }
  },
  computed:
  {
    get_icon_class()
    {
      switch (this.current_animation)
      {
        case 'anim_01':
          return 'nav_icon_01';
        case 'anim_02':
          return 'nav_icon_02';
        case 'anim_03':
          return 'nav_icon_03';
        case 'anim_04':
          return 'nav_icon_03';
        case 'anim_05':
          return 'nav_icon_04';

        case 'anim_06':
          return 'nav_icon_03';
        case 'anim_07':
          return 'nav_icon_05';
        case 'anim_08':
          return 'nav_icon_05';
        
        
        default:
          return 'icon_1';
      }
      
    }
  },
  data() {
    return {
      anim_01_JSON,
      anim_03_JSON,
      anim_04_JSON,
      anim_05_JSON,
      //anim_06_JSON,
      anim_07_JSON,
      anim_08_JSON,
      anim_09_JSON,
      current_animation: "anim_01",
      anim_02_vis: [true, false, false, false],
      anim_06_vis: [true, false, false, false],
      current_section: 1
    }
  }
}
</script>

<style>

@import "./css/style.css";

</style>
